import { render } from "./sales.vue?vue&type=template&id=3487e56c&scoped=true&ts=true"
import script from "./sales.vue?vue&type=script&lang=ts"
export * from "./sales.vue?vue&type=script&lang=ts"

import "./sales.vue?vue&type=style&index=0&id=3487e56c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3487e56c"]])

export default __exports__